import { FETCH_CONTRACTS, SELECT_CONTRACT } from '../constants/action-types';

export function fetchContracts(payload) {
  return { type: FETCH_CONTRACTS, payload };
}

export function selectContract(payload) {
  return { type: SELECT_CONTRACT, payload };
}
